// @flow
import Radio from 'common/domain/radio';

import { MetricsQuery } from '../domain/Metrics';
import MetricsApi from './MetricsApi';

async function fetchIsMissingSampling(radio: Radio, token: string, query: MetricsQuery) {
  const { callSign } = radio;
  const { dateRange, dateRangeCompared } = query;

  const requests = [MetricsApi.getMetricsMetadata(callSign, token, dateRange)];
  if (dateRangeCompared) {
    requests.push(MetricsApi.getMetricsMetadata(callSign, token, dateRangeCompared));
  }

  const metadatas = await Promise.all(requests);
  return metadatas.findIndex(metadata => metadata.isMissingSampling()) !== -1;
}

export default {
  fetchIsMissingSampling,
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/services/MetricsService.js